var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreVertWhite24Dp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430 430",
    color: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m214.2,112.6c10.26,0,18.6-8.34,18.6-18.6s-8.34-18.6-18.6-18.6-18.6,8.34-18.6,18.6,8.34,18.6,18.6,18.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m214.2,233.2c10.26,0,18.6-8.34,18.6-18.6s-8.34-18.6-18.6-18.6-18.6,8.34-18.6,18.6,8.34,18.6,18.6,18.6Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 214.2,
    cy: 335.2,
    r: 18.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVertWhite24Dp);
export default __webpack_public_path__ + "static/media/more_vert_white_24dp.7a1946d988520abc2bccbec293bda7ab.svg";
export { ForwardRef as ReactComponent };